import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../components/Intl/WithIntl';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardImg, CardImgOverlay, Jumbotron, ButtonGroup, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PageWrapper from '../../../components/Content/PageWrapper';
import AppLogo from '../../App/components/view/AppLogo';

function BugPage({ intl, ...props }) {
    console.log(props);
    return (
        <Container className="page-wrapper mt-5 bg-company text-center">
            <PageWrapper>
                <AppLogo suffix="alt" />
                <Card className="mt-5 mb-5 shadow text-center">
                    <CardHeader>
                        <CardTitle>
                            <FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage id="appBugErrorTitle" defaultMessage="Something goes wrong..." />
                        </CardTitle>
                    </CardHeader>
                    <CardBody className="px-3">
                        <FormattedMessage id="appBugErrorText" defaultMessage="Something went wrong.... SORRY ! Please click on the link below to reload this page..." /><br />
                        <ButtonGroup size="sm" className="mt-2">
                            <Button onClick={() => { window.location = '/'; }}><FontAwesomeIcon icon="home" /> <FormattedMessage id="appHome" defaultMessage="Home" /></Button>
                            <Button outline onClick={() => window.location.reload()}><FontAwesomeIcon icon="sync" /> <FormattedMessage id="refresh" defaultMessage="Refresh" /></Button>
                        </ButtonGroup>
                    </CardBody>
                    <CardImg src="/assets/images/illustration-bug.jpg" alt={intl.formatMessage({ id: 'appBugErrorTitle', defaultMessage: 'Something goes wrong...' })} />
                </Card>
            </PageWrapper>
        </Container>
    );
}

BugPage.propTypes = {
    intl: PropTypes.object.isRequired,
};

export default withIntl(BugPage);
